import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Icon } from '../../../../elements';
import { AgentAvatar, StyledAvatar } from './SidebarAgents.styled';

const AgentAvatarComponent = observer(({ photo_url, name, id, isExpanded }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    return (
        <AgentAvatar title={name} isExpanded={isExpanded}>
            {photo_url && !error ? (
                <>
                    {isLoading && (
                        <Icon 
                            name="carbonUserAvatarFilled" 
                            height="32px" 
                            width="32px" 
                            style={{ position: 'absolute' }} 
                        />
                    )}
                    <StyledAvatar
                        src={photo_url} 
                        alt={`${id}`} 
                        sx={{ width: 32, height: 32 }} 
                        loading="lazy"
                        isLoading={isLoading}
                        onLoad={() => setIsLoading(false)}
                        onError={() => setError(true)}
                    />
                </>
            ) : (
                <Icon 
                    name="carbonUserAvatarFilled" 
                    height="32px" 
                    width="32px" 
                />
            )}
        </AgentAvatar>
    );
});

export default AgentAvatarComponent; 